import { useState } from 'react';
import { Box } from '@mui/material';
import { AgingBucket, IAgingPayables } from 'src/types';
import AgingBucketCards from '../receivables/aging-bucket-cards';
import ProducerAgingTable from './producer-aging-table';

type Props = {
  data: IAgingPayables;
};

export default function PayablesSection({ data }: Props) {
  const [activeBucket, setActiveBucket] = useState<AgingBucket | null>(null);

  const handleBucketClick = (bucket: AgingBucket) => {
    setActiveBucket(activeBucket === bucket ? null : bucket);
  };

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <AgingBucketCards
        buckets={data.buckets}
        activeBucket={activeBucket}
        onBucketClick={handleBucketClick}
      />
      <ProducerAgingTable producers={data.producers} activeBucket={activeBucket} />
    </Box>
  );
}
